"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("./valueIsArray"));
const valueIsArrayOfAssertion = (assertion) => ((value) => {
    if (!(0, valueIsArray_1.default)(value)) {
        return false;
    }
    const elementThatDontMatch = value.find((propVal) => !assertion(propVal));
    return !elementThatDontMatch;
});
exports.default = valueIsArrayOfAssertion;
